import { tourKeys } from '../@utils/tourKeys'

export default function getParitySteps() {
    const k = tourKeys('parity')

    return [
        {
            target: '.sticky-header',
            contentKey: k.welcome,
            placement: 'bottom',
            disableBeacon: true,
            disableScrolling: true,
        },
        {
            target: '.select-report-execution-header',
            contentKey: k.reportExecution,
            placement: 'bottom',
            disableScrolling: true,
        },
        {
            target: '.filter-containers',
            contentKey: k.filters,
            placement: 'bottom',
            disableScrolling: true,
        },
        {
            target: '.parity-kpis',
            contentKey: k.kpiCards,
            placement: 'bottom',
            data: {
                beforeNext: () => document.querySelector('.chart-price-compare')?.scrollIntoView({ behavior: 'smooth', block: 'start' }),
                delay: 800,
            },
        },
        {
            target: '.chart-price-compare',
            contentKey: k.globalVision,
            placement: 'top',
        },
        {
            target: '.parity-stat-chart',
            contentKey: k.wmlChart,
            placement: 'top',
        },
        {
            target: '.wml-legend',
            contentKey: k.wmlDetails,
            placement: 'top',
            data: {
                beforeNext: () => document.querySelector('.table-daily-parity')?.scrollIntoView({ behavior: 'smooth', block: 'start' }),
                delay: 800,
            },
        },
        {
            target: '.table-daily-parity',
            contentKey: k.dailyTable,
            placement: 'top',
        },
    ]
}
